import script from "./KategoriInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./KategoriInfo.vue?vue&type=script&setup=true&lang=js"

import "./KategoriInfo.vue?vue&type=style&index=0&id=1edfff56&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1edfff56"]])

export default __exports__